/** Router component */
import React, { Component } from 'react'
import loadable from '@loadable/component'
import { Switch, Route, withRouter, Redirect } from 'react-router-dom'
import { hot } from 'react-hot-loader/root'
import PublicRoute from '../services/router/pubicRoute';
import PrivateRoute from '../services/router/privateRoute';


const Login = loadable(() => import('./pages/login'));
const InvestOnline = loadable(() => import('./pages/login/investonline'));
const NoMatch = loadable(() => import('./pages/nomatch'));
// const Consent = loadable(() => import('./pages/consent1'));
// const ConsentEsign = loadable(() => import('../components/organism/consent/esign'));
// const Consent1 = loadable(() => import('./pages/consent'));
const Cart = loadable(() => import('../components/organism/investmentCart'));
const TransactionStatus = loadable(() => import('./pages/success'));
//const PaymentOLResp = loadable(() => import('./pages/transactionResponse/onlineResp'))
const Emandate = loadable(() => import('./pages/eMandate'));
const checkEmandate = loadable(() => import('./pages/checkEmandate'));

class Router extends Component {

  constructor(props) {
    super(props);
    // Store the previous pathname and search strings
    this.currentPathname = null;
    this.currentSearch = null;
  }

  componentDidMount() {
    //code added for restrict user to use browser back button
    const { history } = this.props;
    // history.listen((newLocation, action) => {
    //   if (action === "PUSH") {
    //     if (
    //       newLocation.pathname !== this.currentPathname ||
    //       newLocation.search !== this.currentSearch
    //     ) {
    //       this.currentPathname = newLocation.pathname;
    //       this.currentSearch = newLocation.search;
    //       history.push({
    //         pathname: newLocation.pathname,
    //         search: newLocation.search
    //       });
    //     }
    //   } else {
    //     history.go(1);
    //   }
    // });
  }
  componentWillUnmount() {
    window.onpopstate = null;
  }

  render() {
    return (
      <React.Fragment>
        <Switch>
          <Route exact path="/">
            <Redirect to="/login" />
          </Route>
          <PublicRoute restricted={false} component={InvestOnline} path="/login" />
          <PrivateRoute restricted={true} hideSidebar={true} strict component={Cart} path="/cart" />
          {/* <PrivateRoute restricted={true} hideSidebar={true} strict component={TransactionStatus} path="/transaction-status" /> */}
          <PrivateRoute restricted={true} hideSidebar={true} strict component={TransactionStatus} path="/paymentStatus" />
          <PrivateRoute restricted={false} hideSidebar={true} component={Emandate} path="/emandate" />
          <PrivateRoute restricted={false} hideSidebar={true} component={checkEmandate} path="/checkEmandate" />
          <Route>
            <NoMatch />
          </Route>
        </Switch>
      </React.Fragment>
    );
  }
}

export default process.env.NODE_ENV === "development" ? withRouter(hot(Router)) : withRouter(Router);
